import React from "react";

import Field from "./Field";

type Props = {
  fields: Array<any>;
  timestamp: string;
  data: any;
  form?: boolean;
  invertColors?: boolean;
};

const FieldContent = ({
  fields,
  timestamp,
  data,
  form = false,
  invertColors = false,
}: Props) => (
  <>
    {fields.map((id) => (
      <Field
        key={id}
        field={data.fields[id]}
        timestamp={timestamp}
        fieldId={parseInt(id, 10)}
        form={form}
        invertBackground={invertColors}
      />
    ))}
  </>
);

export default FieldContent;
